module.exports = __webpack_public_path__ + "media/promo/lum2021/images/congrm-045dc7f8f0af9c2ca05ed3308125e6e8.png";